import type { LinkResolverType } from '@landsbankinn/prismic';
import { Prismic, PrismicText, isEmptyText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { Images, Image } from '../components/slices/Images';

interface IProps {
  aspect_ratio: 'Ar 16:9' | 'Ar 4:3' | 'Ar 1:1';
  fields: IField[];
  featured?: boolean;
  issvg?: boolean;
  template: string;
  columns?: number;
  linkResolver: LinkResolverType;
}

interface IField {
  image: Prismic.Image;
  video: Prismic.Embed;
  image_title: Prismic.RichText;
  image_copy: Prismic.RichText;
}

export const ImagesContainer = ({
  aspect_ratio,
  fields,
  featured,
  template,
  columns,
  issvg = false,
}: IProps) => {
  const items = fields?.filter(({ image, video }) => image || video);
  const _columns = columns !== null && columns !== undefined ? columns : 3;
  if (items.length === 0) {
    return null;
  }
  const isArticle = template === 'article';

  const AspectRatioMap = {
    'Ar 16:9': 'ar_16_9',
    'Ar 4:3': 'ar_4_3',
    'Ar 1:1': 'ar_1_1',
  };

  const isFeaturedAndSquere =
    aspect_ratio === 'Ar 1:1' && featured && items.length === 3;

  return (
    <Segment isArticle={isArticle}>
      <Images
        featured={featured}
        columns={_columns}
        isFeaturedAndSquere={isFeaturedAndSquere}
      >
        {items.map(({ image, video, image_title, image_copy }, key) => {
          // Make last image featured with aspect ratio 16/9
          const aspectRatio = isFeaturedAndSquere
            ? 'ar_1_1'
            : featured && key === items.length - 1
            ? 'ar_16_9'
            : (AspectRatioMap[aspect_ratio] as any);

          return (
            <Image
              title={Prismic.text(image_title)}
              copy={
                !isEmptyText(image_copy) && <PrismicText value={image_copy} />
              }
              key={`image-${key}`}
              image={image}
              video={video}
              ar={aspectRatio}
              isSvg={issvg}
              percentage={
                1 /
                (featured
                  ? key === items.length - 1
                    ? 1
                    : items.length - 1
                  : items.length > 3
                  ? _columns
                  : items.length)
              }
            />
          );
        })}
      </Images>
    </Segment>
  );
};
